module.exports = {"TXTWCL_Close":{"id":"TXTWCL_Close","defaultMessage":"Close","track":"Close"}}